export const getVariableMappingTypeOptions = (keyName, fieldType) => {
  const optionsMap = {
    http: ["mapped", "form", "hardcoded", "na"],
    default: ["mapped", "manual", "hardcoded", "logic", "na"]
  };

  const labelMap = {
    "": "Select type",
    mapped: "Mapped",
    hardcoded: "Hardcoded Value",
    form: "Form Data",
    na: "NA"
  };

  const options = optionsMap[fieldType] || optionsMap[keyName] || optionsMap.default;

  return (
    <>
      {options.map((value, index) => (
        <option key={index} value={value}>
          {labelMap[value] || value}
        </option>
      ))}
    </>
  );
};
